<template>
  <div id="collapseGroup" class="w-full relative">
    <div class="font-bold" v-if="subtitle != ''" :style="'color:' + subtitleColor">{{ t(subtitle) }}:</div>

    <div style="width: 60vw; margin: auto">
      <div v-for="(item, index) in descriptionList" :key="'descriptionList' + index" class="flex flex-col font-jost relative" :class="{ 'text-2xl': fontSize == 'big', 'text-xl': fontSize == 'small' }">
        
        <div class="question-row cursor-pointer" @click="item.expanded = !item.expanded">
          <div class="font-bold" :style="'color: ' + labelColor">{{ t(item.title) }}</div>
          <div class="cursor-pointer ml-auto" style="width: 0.8vw">
          <img src="@/assets/images/shared/minus.svg" style="width: inherit" v-if="item.expanded" />
          <img src="@/assets/images/shared/plus.svg" style="width: inherit" v-if="!item.expanded" />
          </div>
        </div>

        <div class="text-lg my-3.5" v-if="item.titleDescription != undefined" :style="'color:' + descColor">{{ t(item.titleDescription) }}</div>
        <span class="flex space-x-3.5 absolute right-0 top-0 transition ease-in" v-if="item.showShareBtn" :style="[item.expanded ? 'height: auto;opacity:1;z-index:1;	' : 'height: 0px;opacity:0;z-index:-1;transition-duration:0ms;']">
          <img src="@/assets/images/shared/share_grey.svg" style="width: 1vw" class="cursor-pointer" @click="routeTo('comingsoon')" />
          <button-util buttonType="button" bgColor="#603813" label="common.applyNow" @click="routeTo('comingsoon')" />
        </span>
        <div class="transition ease-in" :style="[item.expanded ? 'height: auto;opacity:1;z-index:1;	' : 'height: 0px;opacity:0;z-index:-1;transition-duration:0ms;']">
          <!-- h3 = description title -->
          <span :style="'color:' + descColor" v-html="t(item.description)" class="space-y-5" />
        </div>
        <hr class="my-8" style="border-top: 1px solid black" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useCommonStore } from "@/stores/common";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

import { toRefs } from "vue";

const props = defineProps({
  subtitle: {
    type: String,
    default: "",
  },
  subtitleColor: {
    type: String,
    default: "#494949",
  },
  descriptionList: {
    type: Array,
    default: [],
  },
  labelColor: {
    type: String,
    default: "#494949",
  },
  descColor: {
    type: String,
    default: "#494949",
  },
  fontSize: {
    type: String,
    default: "big",
  },
});
//const { label } = toRefs(props);

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const theme = {
  color: "red",
};
</script>

<style scoped>
>>> .description-title {
  color: v-bind("labelColor");
  font-weight: bold;
}
>>> .description-title:not(:first-child) {
  margin-top: 2vw !important;
}
>>> .question-row {
  display: flex;
  flex-direction: row;
}
</style>